var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA7;}\n\t.st1{fill:#FDC95F;}\n\t.st2{fill:#F7A93C;}\n\t.st3{fill:none;stroke:#F6A200;stroke-width:1.7175;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.31,83.96c0,0-4.63-5.1-2.6-6.86c2.03-1.75,15.2-0.82,24.54,5.9c3.66,2.63,7.29,5.37,10.37,8.69 c2.52,2.71,4.45,6.35,8.65,6.32c3.52-0.03,5.03-3.97,5.87-7.53c0.83-3.56,0.14-7.96,9.5-15.58s12.91-10.59,15.77-10.07 c2.86,0.52,1.77,4.58,1.4,6.29s-3.56,5.18,0.02,4.77c3.57-0.41,7.26-1.41,8.17,0.38c0.91,1.79-1.34,3.93-2.14,5.98 s-1.5,3.32,1.56,3.73c3.06,0.41,6.27-0.33,6.88,2.17c0.6,2.49-2.5,4.23-4.42,6.01c-1.92,1.78-0.19,3.29,2.05,3.98 c2.24,0.69,4.98,0.84,5.24,2.73c0.26,1.89-2.84,3.45-4.48,4.63c-1.64,1.18-2.47,1.91-0.66,3.56s4.54,2.59,4.56,4.35 s-2.83,2.21-5.1,3.21c-2.27,1.01-4.69,0.95-2.28,4.46c2.41,3.52,4.64,5.28,3.47,6.2c-1.17,0.92-6.96,1.16-8.17,1.21 c-1.21,0.06-1.11,1.33,0.13,2.76s3.59,2.77,2.28,5.98c-1.3,3.21-3.95,3.54-11.83-0.27c-4.89-2.36-9.85-4.91-13.9-8.57 c-2.07-1.87-3.77-3.99-5.02-6.48c-1.1-2.17-1.78-5.12-3.59-6.84c-1.7-1.61-7.19-0.84-7.53,4.57s0.13,9.39-5.64,16.78 c-5.77,7.39-12.42,13.06-15.19,13.64c-2.77,0.58-6.35-2.02-4.66-6.42c1.69-4.4,2.63-5.72-1.14-5.2c-3.78,0.52-8.99,2.12-7.05-1.54 c1.94-3.65,2.93-6.77,0.56-7.21s-8.4,0.64-8.78-1.45c-0.37-2.09,3.78-3.36,4.76-6.03c0.98-2.67-1.31-2.98-3.84-3.69 c-2.52-0.71-6.92-0.99-3.84-3.69c3.09-2.7,6.75-5.02,3.68-7.02c-3.07-2-8.49-3.47-4.7-5.86s8.07-3.28,6.04-5.33 c-2.03-2.05-8.79-6.22-4.84-7.38s8.18-1.66,7.74-2.92C66.71,85.04,65.31,83.96,65.31,83.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.81,106.28c0,0-12.31-0.18-17.17-0.65c-4.86-0.46-7.4,3.53-6.24,8.45c1.16,4.92,2.94,7.46,9.54,4.39 c6.59-3.07,12.88-5.27,14.43-7.73C99.9,108.29,97.81,106.28,97.81,106.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.17,95.89c0,0-8.12,4.46-14.16,5.99c-6.05,1.53-7.62,1.88-7.02,3.58c0.6,1.7,0.87,1.55,7.72,3.99 c6.85,2.44,11.44,5.27,13.82,5.71c2.37,0.44,3.02-7.09,2.31-9.78s2.84-5.04,2.19-7.78C142.37,94.86,138.17,95.89,138.17,95.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.5,105.98c0,0,5-1.98,9.9-2.15c3.85-0.14,4.89-0.44,4.89-0.44"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasta);
export default __webpack_public_path__ + "static/media/Pasta.be6f394cad81506fab20dcdff6e5dea9.svg";
export { ForwardRef as ReactComponent };